import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { usePermissions } from './usePermissions';

/**
 * Route guard: renders children when user has the required permission,
 * otherwise redirects to home.
 *
 * @param {Object} props
 * @param {string} [props.permission] - Permission codename (e.g. api.view_annotation)
 * @param {React.ReactNode} [props.children] - Content to render when allowed
 */
export function RequirePermission({ permission, children }) {
    const { hasPermission } = usePermissions();
    const location = useLocation();

    if (!permission) {
        return children;
    }

    if (!hasPermission(permission)) {
        return <Navigate to='/' state={{ from: location }} replace />;
    }

    return children;
}
